<template>
  <span>{{secondsToTime(seconds) + " 后复查"}}</span>
</template>

<script>

export default {
  name: "timer",
  components: {
  },
  props: ['val','index'],

  data(){
    return{
      seconds:0,
      timer:null,
    }
  },
  created() {
    this.seconds = this.val
    this.timer = setInterval(() => {
      this.seconds = this.seconds -1;
      if(this.seconds == 0){
        clearInterval( this.timer);
        this.$emit('over', this.index)
      }
      this.$forceUpdate(); // 强制Vue重新渲染
    }, 1000);
  },
  methods: {
    secondsToTime(seconds) {
      var minutes = Math.floor((seconds) / 60);
      var seconds = seconds - (minutes * 60);
      seconds = Math.round(seconds * 100) / 100;
      var result = (minutes < 10 ? "0" + minutes : minutes) + ":" + (seconds < 10 ? "0" + seconds : seconds);
      return result;
    },
  },
}



</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/page/oil/timer.vue